export enum TableIds {
  AccessTokens = 'access-tokens',
  AccountStatementsTable = 'account-statements-table',
  AccountsTable = 'accounts-table',
  BillsList = 'bills-list',
  ContactPersonsTable = 'contact-persons-table',
  ClientExternalInvoicesList = 'client-external-invoices-list',
  ClientQuotesTable = 'client-quotes-table',
  ContactsTable = 'contacts-table',
  ContactBalanceList = 'contact-balance-list',
  ContactPersonsList = 'contact-persons-list',
  CurrencyDefaultPaymentMethods = 'currency-default-payment-methods',
  CustomersBalance = 'customers-balance',
  DuplicateBill = 'duplicate-bill',
  ExternalInvoicesList = 'external-invoices-list',
  ImportedInvoicesList = 'imported-invoices-list',
  InvoiceTemplates = 'invoice-templates',
  InvoicesList = 'invoices-list',
  MissingInformations = 'missing-informations',
  MissingReceipts = 'missing-receipts',
  Organizations = 'organizations-list',
  OrganizationOwners = 'oraganization-owners',
  PaymentMethods = 'payment-methods',
  QuotesTable = 'quotes-table',
  RecurringInvoicesList = 'recurring-invoices-list',
  ReviewEntries = 'review-entries',
  SalesTax = 'sales-tax',
  SalesOverviewReport = 'sales-overview-report',
  SalesByItemReport = 'sales-by-item-report',
  SalesByCustomerReport = 'sales-by-customer-report',
  SuggestionsTable = 'suggestions-table',
  SuppliersBalance = 'suppliers-balance',
  TransactionsList = 'transactions-list',
  UmbrellaOrganizationsList = 'umbrella-organizations-list',
  VatDeclarations = 'vat-declarations',
  VoucherList = 'voucher-list',
}
